var map = {
	"./angle-down.svg": 93810,
	"./angle-left.svg": 14041,
	"./angle-right.svg": 59140,
	"./angle-solid-down.svg": 70432,
	"./angle-up.svg": 37281,
	"./badge-award-gold.svg": 37072,
	"./badge-award-silver.svg": 33189,
	"./badge-verified.svg": 76650,
	"./card-success.svg": 5464,
	"./case.svg": 14208,
	"./check-circle.svg": 46385,
	"./check.svg": 19428,
	"./coins.svg": 99994,
	"./cross.svg": 53444,
	"./dots.svg": 30848,
	"./email.svg": 95012,
	"./exclamation-circle.svg": 40012,
	"./exclamation-triangle.svg": 29676,
	"./gift.svg": 72726,
	"./globe.svg": 86155,
	"./heart-stroke.svg": 99029,
	"./heart.svg": 93776,
	"./info-circle.svg": 13629,
	"./joystick.svg": 1438,
	"./link-outer.svg": 94274,
	"./link.svg": 90620,
	"./lock.svg": 93793,
	"./message-bubble.svg": 30724,
	"./microphone.svg": 75372,
	"./money-bag.svg": 98509,
	"./no-avatar.svg": 52673,
	"./no-microphone.svg": 25442,
	"./pause.svg": 55618,
	"./payment-apple-pay.svg": 65496,
	"./payment-boleto-flash.svg": 40757,
	"./payment-br-bank.svg": 19770,
	"./payment-br-card.svg": 59370,
	"./payment-cards-rub.svg": 21632,
	"./payment-cards.svg": 79324,
	"./payment-cryptocurrencies.svg": 64449,
	"./payment-faster-payments-system.svg": 14118,
	"./payment-google-pay.svg": 41903,
	"./payment-klarna.svg": 5644,
	"./payment-mastercard.svg": 43287,
	"./payment-paypal.svg": 52778,
	"./payment-paysafe.svg": 70836,
	"./payment-pix.svg": 38706,
	"./payment-qiwi.svg": 77369,
	"./payment-sberbank.svg": 65351,
	"./payment-sberpay.svg": 92613,
	"./payment-sms.svg": 92718,
	"./payment-trustly.svg": 61050,
	"./payment-visa.svg": 12016,
	"./payment-vkpay.svg": 37720,
	"./payment-webmoney.svg": 75529,
	"./payment-y-money.svg": 91947,
	"./pencil.svg": 64915,
	"./phone.svg": 1736,
	"./play.svg": 10802,
	"./plus.svg": 39612,
	"./poll.svg": 28795,
	"./question-circle.svg": 85789,
	"./social-appleid.svg": 64925,
	"./social-boosty.svg": 29540,
	"./social-dailymotion.svg": 1371,
	"./social-discord.svg": 21590,
	"./social-donationalerts.svg": 51105,
	"./social-facebook.svg": 63302,
	"./social-fb.svg": 49026,
	"./social-goodgame.svg": 79343,
	"./social-mixer.svg": 39861,
	"./social-ok.svg": 75776,
	"./social-periscope.svg": 30192,
	"./social-smashcast.svg": 3999,
	"./social-telegram-colored.svg": 77726,
	"./social-telegram.svg": 21427,
	"./social-tiktok.svg": 95300,
	"./social-trovo.svg": 22290,
	"./social-twitch.svg": 6151,
	"./social-vk-user.svg": 50517,
	"./social-vk.svg": 58171,
	"./social-wasd.svg": 98283,
	"./social-youtube-official.svg": 85857,
	"./social-youtube.svg": 58777,
	"./speaker.svg": 72215,
	"./speech-synthesis.svg": 88647,
	"./spinner.svg": 11339,
	"./sticker.svg": 22937,
	"./stop.svg": 164,
	"./success.svg": 23957,
	"./trash.svg": 55010,
	"./trovo.svg": 82608,
	"./user.svg": 9373,
	"./verified.svg": 91592,
	"./wallet.svg": 17411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87142;